var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "school"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_46",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 60,
    height: 60,
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "school_2",
    d: "M52.5 39.9998V25.2498L32.375 36.1873C31.625 36.6039 30.8333 36.8123 30 36.8123C29.1667 36.8123 28.375 36.6039 27.625 36.1873L6.5 24.6873C6.04167 24.4373 5.71875 24.1248 5.53125 23.7498C5.34375 23.3748 5.25 22.9581 5.25 22.4998C5.25 22.0414 5.34375 21.6248 5.53125 21.2498C5.71875 20.8748 6.04167 20.5623 6.5 20.3123L27.625 8.81226C28 8.60392 28.3854 8.44767 28.7812 8.34351C29.1771 8.23934 29.5833 8.18726 30 8.18726C30.4167 8.18726 30.8229 8.23934 31.2188 8.34351C31.6146 8.44767 32 8.60392 32.375 8.81226L56.1875 21.8123C56.6042 22.0206 56.9271 22.3227 57.1562 22.7185C57.3854 23.1143 57.5 23.5414 57.5 23.9998V39.9998C57.5 40.7081 57.2604 41.3018 56.7813 41.781C56.3021 42.2602 55.7083 42.4998 55 42.4998C54.2917 42.4998 53.6979 42.2602 53.2188 41.781C52.7396 41.3018 52.5 40.7081 52.5 39.9998ZM27.625 51.1873L15.125 44.4373C14.2917 43.9789 13.6458 43.3539 13.1875 42.5623C12.7292 41.7706 12.5 40.9164 12.5 39.9998V30.4998L27.625 38.6873C28.375 39.1039 29.1667 39.3123 30 39.3123C30.8333 39.3123 31.625 39.1039 32.375 38.6873L47.5 30.4998V39.9998C47.5 40.9164 47.2708 41.7706 46.8125 42.5623C46.3542 43.3539 45.7083 43.9789 44.875 44.4373L32.375 51.1873C32 51.3956 31.6146 51.5518 31.2188 51.656C30.8229 51.7602 30.4167 51.8123 30 51.8123C29.5833 51.8123 29.1771 51.7602 28.7812 51.656C28.3854 51.5518 28 51.3956 27.625 51.1873Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.c1c30d9aee72c81505b2a6c69dae9358.svg";
export { ForwardRef as ReactComponent };